import React from 'react';
import { Box, Typography } from '@mui/material';
import { color, font } from '../styles/tokens';

// Reuses the signal-bar motif from the masthead ticker so a loading state
// reads as "the wire is active" rather than a generic spinner bolted on.
const Loader = ({ minHeight = 200, label = 'Syncing the wire…' }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
      minHeight,
      width: '100%',
      py: 4,
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: '4px', height: 32 }} aria-hidden="true">
      {[35, 65, 100, 65, 35].map((h, i) => (
        <Box
          key={i}
          sx={{
            width: 5, height: `${h}%`, background: color.teal,
            boxShadow: `0 0 8px ${color.tealGlow}`,
            animation: 'wd-bar 1.1s ease-in-out infinite',
            animationDelay: `${i * 0.12}s`,
          }}
        />
      ))}
    </Box>
    <Typography sx={{
      fontFamily: font.mono, fontSize: '.75rem', letterSpacing: '.14em', textTransform: 'uppercase',
      color: color.boneFaint,
    }}>
      {label}
    </Typography>
  </Box>
);

export default Loader;
